import { css } from '@emotion/react';
import type { ButtonHTMLAttributes } from 'react';

import IconSend16Filled from '~icons/fluent/send-16-filled';

import { theme } from '@adflow/frontend/ui-theme';

import { buttonIconAddStyles } from './ButtonIconAdd';

const styles = {
	icon: css({
		color: theme.colors.palettes.primary.contrastText,
		width: 14,
		height: 14,
	}),
	circle: css({
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',

		width: 24,
		height: 24,
		borderRadius: '50%',
		backgroundColor: theme.colors.palettes.primary.main,
		paddingLeft: 2,
	}),
};

export const buttonSendStyles = styles;

export type ButtonSendProps = ButtonHTMLAttributes<HTMLButtonElement>;

export function ButtonSend(props: ButtonSendProps) {
	return (
		<button
			type="button"
			{...props}
			data-testid="button-send"
			css={buttonIconAddStyles.addButton}
		>
			<div css={styles.circle}>
				<IconSend16Filled css={[buttonIconAddStyles.icon, styles.icon]} />
			</div>
		</button>
	);
}
